const scrollProgress = () => {
  const progressBar = document.getElementById('js-progress-bar')
  const header = document.getElementById('js-header')

  const headerScroll = () => {
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop
    const height =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight
    const scrolled = (winScroll / height) * 100

    const changeHeaderState = (state) => {
      state === 'add'
        ? header.classList.add('header-transition')
        : header.classList.remove('header-transition')
    }

    progressBar.value = scrolled
    Math.floor(progressBar.value) >= 1
      ? changeHeaderState('add')
      : changeHeaderState('remove')
  }

  /* On Page Load */
  headerScroll()

  window.addEventListener('scroll', () => {
    if (!progressBar) return
    headerScroll()
  })
}

export default scrollProgress
